<div class="modal-header" >
  <h3 class="modal-title">{{ isMultipleDelete ? 'Delete Multiple Locations' : 'Delete location' }}</h3>
  <button
  (click)="bsModalRef.hide()"
  type="button"
  class="close"
  aria-label="Close"
>
  <span aria-hidden="true">&times;</span>
</button>
</div>

  <div class="modal-body">
      <div class="row">
          <div class="col-12 d-grid">
            <span *ngIf="!isMultipleDelete">You are just about to remove the location
           <b> {{ selectedLocation.address?.street }}
            {{ selectedLocation.address?.street2 }}
            {{ selectedLocation.address?.house_no }},
            {{ selectedLocation.address?.zip }}
            {{ selectedLocation.address?.city }}</b>, are you sure?</span>

            <span *ngIf="isMultipleDelete">You are about to delete <b>{{ selectedCount }} selected locations</b>.
            This action cannot be undone. Are you sure you want to proceed?</span>
          </div>
      </div>
  </div>

<div class="modal-footer">
  <div class="row row-spacer">
      <div class="col-12 d-flex">
        <button (click)="bsModalRef.hide()" class="btn btn-danger" style="margin-right:10px !important;">
          Cancel
        </button>
        <button (click)="deleteLocation()" class="btn btn-ancotrans" style="margin-right:10px !important;">
          {{ isMultipleDelete ? 'Delete All' : 'Delete' }}
        </button>
      </div>
    </div>
</div>
